/* Tysk katalog for locale-pension-invoice-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'otp.sourceRequired': 'Dokument aus dem Posteingang oder bestehender Beleg',
  'otp.positivePremium': 'Pensionsprämie größer als 0 kr',
  'otp.completeBeforePreview': 'Fülle aus oder wähle, bevor du den Kontierungsvorschlag anzeigst:',
  'otp.unlinked': 'Lohnrückstellungen ohne Rechnungsverknüpfung',
  'otp.alreadyPosted': 'Bereits gebuchte Kosten und Zahlung',
  'otp.noAccruals': 'Keine verfügbaren Lohnrückstellungen. Bereits bezahlte Rückstellungen müssen korrigiert werden, bevor sie mit einer Rechnung verknüpft werden können.',
  'otp.inboxNotice': 'Das sieht nach einer Pensionsrechnung (OTP) aus. Erfasse sie über Pension/OTP, um sie mit Lohnrückstellungen abzurechnen und die Arbeitgeberabgabe korrekt zu behandeln.',
  'otp.open': 'In Pension/OTP öffnen',
  'otp.dismiss': 'Betrifft nicht OTP',
  'otp.invoices': 'Pensionsrechnungen und Abrechnung',
  'otp.register': 'Pensionsrechnung erfassen',
  'otp.flow': 'Verknüpfe die Rechnung zuerst mit den Lohnrückstellungen. Die Zahlung wird einmal auf der Rechnung erfasst. Die Arbeitgeberabgabe folgt dem tatsächlichen Zahlungsmonat.',
  'otp.invoice': 'Rechnung',
  'otp.actual': 'Tatsächliche Kosten',
  'otp.accrued': 'Abgerechnete Rückstellung',
  'otp.paid': 'Bezahlt',
  'otp.remaining': 'Verbleibend',
  'otp.aga': 'AGA verarbeitet',
  'otp.reported': 'Meldung erfasst',
  'otp.notReported': 'Meldung nicht erfasst',
  'otp.reportingReview': 'A-melding muss geprüft werden',
  'otp.reportingWarning': 'Für den Zahlungsmonat ist bereits eine A-melding erfasst. Die Zahlung kann erfasst werden, du musst die A-melding aber mit der aktualisierten Pensions- und AGA-Grundlage prüfen und gegebenenfalls korrigieren. Die frühere Einreichung wird nicht automatisch geändert.',
  'otp.annulled': 'Verknüpfung storniert',
  'otp.details': 'Details ansehen',
  'otp.document': 'Dokument aus dem Posteingang',
  'otp.existing': 'Mit bestehendem Beleg verknüpfen',
  'otp.supplierName': 'Lieferant',
  'otp.invoiceNumber': 'Rechnungsnummer',
  'otp.invoiceDate': 'Rechnungsdatum',
  'otp.dueDate': 'Fälligkeitsdatum',
  'otp.date': 'Abrechnungsdatum',
  'otp.premium': 'Pensionsprämie des Arbeitgebers',
  'otp.administration': 'Pensionsverwaltung (ohne MwSt.)',
  'otp.components': 'Bestätige, dass die Beträge die Arbeitgeberprämie und gegebenenfalls die Verwaltung der Pensionsregelung ohne MwSt. betreffen. Arbeitnehmeranteil, Übertragungsgebühren und andere Bestandteile müssen gesondert geklärt werden, bevor dieser Ablauf verwendet wird.',
  'otp.selectAccruals': 'Wähle die Lohnrückstellungen, die die Rechnung betrifft',
  'otp.preview': 'Kontierungsvorschlag anzeigen',
  'otp.difference': 'Differenz zur Rückstellung',
  'otp.existingPreview': 'Der bestehende Einkauf und die Zahlung bleiben erhalten. Unten werden nur die Abrechnung und eine eventuelle Umgliederung angezeigt. Positive Beträge sind Soll, negative Haben.',
  'otp.newPreview': 'Die Rechnung wird auf 5950 gegen Lieferantenverbindlichkeiten 2400 gebucht. Unten wird die Abrechnung früherer Rückstellungen angezeigt. Positive Beträge sind Soll, negative Haben. Die Zahlung wird separat erfasst.',
  'otp.confirm': 'Rechnung und Abrechnung bestätigen',
  'otp.saved': 'Die OTP-Erfassung wurde gespeichert.',
  'otp.purchasePosting': 'Einkaufsbeleg ansehen',
  'otp.allocationPosting': 'Abrechnung ansehen',
  'otp.paymentDocumented': 'Erfasse nur eine dokumentierte Zahlung, die noch nicht gebucht ist. Dabei wird keine Banküberweisung ausgeführt.',
  'otp.reversePayment': 'Zahlung stornieren',
  'otp.annulLink': 'Abrechnung stornieren',
  'otp.annulExplanation': 'Die Abrechnung und die zugehörige AGA werden gegengebucht. Einkaufsrechnung und Zahlung bleiben erhalten. Verknüpfe die Rechnung anschließend erneut mit den richtigen Rückstellungen. Dies ändert keine Banküberweisung.',
});
